export const CONTAINER_INITIAL_STATE = {
  list: [],
  selected: {
    name: '',
    tax_year: '',
  },
};

export const MAX_TABLE_HEIGHT = '90%'
